import * as R from 'ramda'

import { updateBlock } from 'services/Store/Project/actions'
import { decrementZIndex } from 'services/Store/Project/mutators/node'
import { getBlock, getDeviceMode, getSelectedNodeIds } from 'services/Store/Project/selectors'
import type { Block } from 'services/Store/Project/types'
import store from 'services/Store/store'

export const onSendBackward = async () => {
  const state = store.getState().project
  const dispatch = store.dispatch
  const block = getBlock(state)
  const device = getDeviceMode(state)
  const selectedNodes = getSelectedNodeIds(state)
  // const selected = selectedNodes.map((id) => block && block.schema.nodes[id]).filter(isNodeV2)
  // const parent = getParentNode(selectedNodes?.[0], block)
  // const parentStyle = mergeNodeStyle(parent?.style || {}, device)
  // const isFlexFlow = getIsFlexFlow(state, selected)

  if (block /* && (isGrid(parentStyle) || isAbsolute(parentStyle) || isFlexFlow) */) {
    const cbs = selectedNodes.map((id) => decrementZIndex(id, device)) as [(block: Block) => Block]
    dispatch(updateBlock({ id: block.uuid, value: R.compose(...cbs)(block) }))
  }
}
